module.exports = __webpack_public_path__ + "static/media/bowling.b1744444.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/bowling.svg
// module id = 366
// module chunks = 7